/**
 * Shared utility functions for timetable management
 */

/**
 * Map ATHS to ATS for display purposes
 */
export function getDisplayEntityCode(entityCode) {
  if (!entityCode) return '';
  return entityCode === 'ATHS' ? 'ATS' : entityCode;
}

/**
 * Format date string to readable format
 */
export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

/**
 * Get program display name with department info
 */
export function getProgramDisplayName(program) {
  if (!program) return '';
  let displayName = '';
  if (program.program_department && program.program_department.entity && program.program_department.name) {
    const entityCode = getDisplayEntityCode(program.program_department.entity);
    displayName = `${entityCode} - ${program.program_department.name}`;
  }
  if (program.name) {
    displayName = displayName ? `${displayName} - ${program.name}` : program.name;
  }
  return displayName;
}

/**
 * Get program display label with entity, campus, department and program
 * Format: Entity - Campus - Department - Program (e.g. FCHS - FCHS-MAFRAQ - Nursing - BSc in Nursing)
 */
export function getProgramDisplayLabelWithCampus(program) {
  if (!program) return '';
  const entity = program.program_department && program.program_department.entity
    ? getDisplayEntityCode(program.program_department.entity)
    : '-';
  const campus = program.program_department && program.program_department.campus
    ? program.program_department.campus
    : '-';
  const department = program.program_department && program.program_department.name
    ? program.program_department.name
    : '-';
  const programName = program.name || '-';
  return `${entity} - ${campus} - ${department} - ${programName}`;
}

/**
 * Get semester display label with entity, campus, department, program and semester name
 * Format: Entity - Campus - Department - Program - Semester Name (e.g. FCHS - FCHS-AJMAN - Nursing - BSc in Nursing - Winter Semester 2025-2026)
 */
export function getSemesterDisplayLabelWithCampus(semester) {
  if (!semester) return '';
  const programLabel = getProgramDisplayLabelWithCampus(semester.program);
  const semesterName = semester.name || '';
  return programLabel ? `${programLabel} - ${semesterName}` : semesterName;
}

/**
 * Entity order for sorting
 */
export const ENTITY_ORDER = ['FCHS', 'ADPOLY', 'ATHS', 'ATS', 'ADVETI'];

/**
 * Get entity order index for sorting
 */
export function getEntityOrderIndex(entity) {
  if (!entity) return 999;
  const normalizedEntity = entity === 'ATHS' ? 'ATS' : entity;
  const index = ENTITY_ORDER.indexOf(normalizedEntity);
  return index !== -1 ? index : 999;
}
